import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/routers/constant'

const router: Array<RouteRecordRaw> = [
  {
    path: '/sample',
    component: Layout,
    redirect: '/sample/index',
    meta: {
      title: '样本管理',
      keepAlive: true,
      requiresAuth: false,
      auth: ['inspection', 'inspection_verification']
    },
    children: [
      {
        path: 'index',
        name: 'SampleIndex',
        component: () => import('@/views/app/sample/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: false,
          title: '样本管理',
        }
      }
    ]
  }
]

export default router
